<template>
<div class="page-shell guide-page">
  <HeadNav />

  <main>
    <section class="guide-hero">
      <div class="site-container">
        <p class="eyebrow">GB WhatsApp help center</p>
        <h1>GB WhatsApp Guides - Tips, How-To &amp; Troubleshooting</h1>
        <p>
          Find practical GB WhatsApp guides for installation, updates, backups, privacy settings, features, troubleshooting, and common problems.
        </p>
      </div>
    </section>

    <section class="site-section guide-index">
      <div class="site-container">
        <div class="section-heading">
          <p class="section-kicker">In-depth guides</p>
          <h2>Step-by-step help for everyday WhatsApp tasks</h2>
          <p>Each guide explains how a feature works in practice and points out where GB WhatsApp options may differ from the standard app.</p>
        </div>

        <div class="grid two">
          <router-link class="guide-card" to="/meta-ai-advantages/">
            <span class="guide-media">
              <img src="@/assets/guide-meta-ai.svg" alt="Meta AI replying inside a GB WhatsApp chat" loading="lazy">
            </span>
            <span class="guide-body">
              <span class="guide-label">AI features</span>
              <h3>How to Use Meta AI on GB WhatsApp | Advantages and Effectiveness</h3>
              <p>Explore Meta AI on WhatsApp, including content creation, business ideas, personalized stickers, and real-time information without a separate sign-up.</p>
              <span class="link-arrow">Read the Meta AI guide</span>
            </span>
          </router-link>

          <router-link class="guide-card" to="/share-view-once-photos/">
            <span class="guide-media">
              <img src="@/assets/guide-view-once.svg" alt="View once photo and video sharing on GB WhatsApp" loading="lazy">
            </span>
            <span class="guide-body">
              <span class="guide-label">Privacy and media</span>
              <h3>Methods to Share View Once Photos on WhatsApp 2026</h3>
              <p>Learn how to send view once photos and videos, understand their privacy limits, and see when GB WhatsApp may offer additional media options.</p>
              <span class="link-arrow">Read the View Once guide</span>
            </span>
          </router-link>
        </div>
      </div>
    </section>

    <section class="site-section compact soft guide-next">
      <div class="site-container guide-next-inner">
        <div>
          <h2>Need the app or an older build?</h2>
          <p>Get the current APK or review compatibility notes before you install anything.</p>
        </div>
        <div class="guide-next-links">
          <router-link class="button button-primary" to="/download/">Download GB WhatsApp</router-link>
        </div>
      </div>
    </section>
  </main>
</div>
</template>

<script>
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'GuideIndex',
  components: {
    HeadNav,
  },
};
</script>

<style lang="scss" scoped>
.guide-hero {
  padding: 62px 0 54px;
  background:
    linear-gradient(rgba(22, 163, 74, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(22, 163, 74, 0.05) 1px, transparent 1px),
    linear-gradient(180deg, #eef7f1 0%, #f7fbf8 100%);
  background-size: 42px 42px, 42px 42px, auto;
  border-bottom: 1px solid var(--line);
}

/* 与 .site-container 同宽换行，避免标题/导语在栏内过早折行 */
.guide-hero .site-container > h1,
.guide-hero .site-container > p:last-child {
  max-width: none;
  width: 100%;
}

.guide-hero h1 {
  margin-bottom: 20px;
  color: var(--ink);
  font-size: clamp(28px, 3.6vw, 40px);
}

.guide-hero p:last-child {
  margin-bottom: 0;
  color: var(--ink-soft);
  font-size: 18px;
}

/* Let the guide cards use the full content width before wrapping. */
.guide-index .section-heading {
  max-width: none;
}

.guide-card {
  display: flex;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: #ffffff;
  box-shadow: var(--shadow-sm);
  transition:
    transform 180ms ease,
    border-color 180ms ease,
    box-shadow 180ms ease;
}

.guide-card:hover {
  transform: translateY(-4px);
  border-color: #bee8c8;
  box-shadow: var(--shadow-md);
}

.guide-media {
  display: block;
  overflow: hidden;
  aspect-ratio: 16 / 10;
  border-bottom: 1px solid var(--line);
  background: #eaf4ed;
}

.guide-media img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 320ms ease;
}

.guide-card:hover .guide-media img {
  transform: scale(1.03);
}

.guide-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 22px 24px 24px;
}

.guide-label {
  align-self: flex-start;
  margin-bottom: 14px;
  padding: 6px 10px;
  border-radius: 999px;
  background: #e9f3ec;
  color: var(--green-dark);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.guide-body h3 {
  margin-bottom: 10px;
  font-size: 20px;
  line-height: 1.32;
}

.guide-body p {
  margin-bottom: 20px;
  font-size: 15px;
  line-height: 1.6;
}

.guide-body .link-arrow {
  margin-top: auto;
}

.guide-next-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
}

.guide-next h2 {
  margin-bottom: 6px;
  font-size: 22px;
}

.guide-next p {
  margin-bottom: 0;
}

.guide-next-links {
  display: flex;
  flex: none;
  flex-wrap: wrap;
  gap: 12px;
}

@media (max-width: 760px) {
  .guide-hero {
    padding: 44px 0 38px;
  }

  .guide-hero p:last-child {
    font-size: 17px;
  }

  .guide-next-inner {
    align-items: flex-start;
    flex-direction: column;
  }

  .guide-next-links {
    width: 100%;
  }

  .guide-next-links .button {
    flex: 1 1 auto;
  }
}

</style>
